module.exports = __webpack_public_path__ + "img/3.16e4558c.jpg";